import BambeeLogo from '@/components/BambeeLogo.vue';
import shortid from 'shortid';
import {
  TypeBody,
  TypeDisplay,
  TypeHeading,
  TypeOverline,
  BaseCard,
  BaseDivider,
  BaseButton,
  TextInput,
  BaseIcon,
  AvatarImage,
} from '@bambeehr/pollen';
import ContentCard from '@/modules/HomePage/components/ContentCard.vue';
import RootHomePage from '@/modules/HomePage/pages/RootHomePage.vue';
import SplashPage from '@/modules/SplashPage';
import PricingRoot from '@/modules/InformationPages/Pricing/components/PricingRoot.vue';
import FaqRoot from '@/modules/InformationPages/Faq/components/FaqRoot.vue';
import InsuranceRoot from '@/modules/InformationPages/Insurance/components/InsuranceRoot.vue';
import PartnersRoot from '@/modules/InformationPages/Partners/components/PartnersRoot.vue';
import ProductRoot from '@/modules/InformationPages/Product/components/ProductRoot.vue';
import ReviewsRoot from '@/modules/InformationPages/Reviews/components/ReviewsRoot.vue';
import ScheduleCallLanding from '@/modules/LandingPages/components/ScheduleCallLanding.vue';
import TrainingRoot from '@/modules/InformationPages/Training/components/TrainingRoot.vue';
import AboutRoot from '@/modules/About/pages/AboutRoot.vue';
import ComplianceRoot from '@/modules/InformationPages/Compliance/components/ComplianceRoot.vue';
import ComplianceTemplate from '@/modules/InformationPages/Compliance/components/ComplianceTemplate.vue';
import LegalRoot from '@/modules/InformationPages/Legal/components/LegalRoot.vue';
import LegalTemplate from '@/modules/InformationPages/Legal/components/LegalTemplate.vue';
import IndustryRoot from '@/modules/InformationPages/Industries/components/IndustryRoot.vue';
import IndustryTemplate from '@/modules/InformationPages/Industries/components/IndustryTemplate.vue';
import EmployeeDropdown from '@/components/EmployeeDropdown.vue';
import RegistrationPrompt from '@/components/RegistrationPrompt.vue';
import HomeNav from '@/modules/HomePage/components/Navigation/HomeNav.vue';
import MobileMenu from '@/modules/HomePage/components/Navigation/MobileMenu.vue';
import TheFooter from '@/components/Navigation/TheFooter.vue';
import PricingPlans from '@/modules/InformationPages/Pricing/components/PricingPlans.vue';
import SimpleImage from '@/components/SimpleImage.vue';
import SmartImage from '@/components/SmartImage.vue';
import Accordion from '@/components/Accordion/Accordion.vue';
import AccordionPanel from '@/components/AccordionPanel/AccordionPanel.vue';
import Catalog from '@/modules/InformationPages/Blog/pages/Catalog.vue';
import ReferredBlogs from '@/modules/InformationPages/Blog/components/ReferredBlogs.vue';
import BlandHero from './components/BlandHero.vue';
import HomeHero from '@/modules/HomePage/components/HomeHero.vue';
import { HeroContent } from '@/modules/HomePage/constants/index';
import PurpleHexContainer from '@/components/PurpleHexContainer.vue';
import ZigZagLayout from '@/components/ZigZagLayouts/ZigZagLayout.vue';
import ZigZagLayoutContainer from '@/components/ZigZagLayouts/ZigZagLayoutContainer.vue';
import BaseCTABlade from '@/components/CTABlade/BaseCTABlade.vue';
import Hero from '@/components/Hero/BaseHero.vue';
import BaseTestimonial from '@/components/Testimonial/BaseTestimonial.vue';
import BaseFAQ from '@/components/FAQ/BaseFAQ.vue';
import FeatureSummary from '@/components/FeatureSummary.vue';
import BaseBenefitsBlade from '@/components/BenefitsBlade/BaseBenefitsBlade.vue';
import ValueBlade from '@/components/ValueBlade.vue';
import { CustomComponentName } from '@/constants/CustomComponentNames';
import PageSubHero from '@/components/PageSubHero.vue';
import SimpleFooter from '@/components/Navigation/SimpleFooter.vue';
import ProfileFactoid from '@/components/ProfileFactoid/BaseProfileFactoid.vue';
import Factoid from '@/components/Factoid.vue';
import ProfileCardVue from './components/ProfileCard/ProfileCard.vue';
import { promotionType } from '@/modules/SplashPage/constants/Campaign';

interface IProps {
  name: string;
  type: any;
  defaultValue?: any;
  helperText?: string;
  allowedFileTypes?: string[];
  subFields?: {
    name?: string;
    type?: any;
    defaultValue?: any;
    helperText?: string;
    required?: boolean;
  }[];
  required?: boolean;
  enum?: any[];
}

interface IComponent {
  component: any;
  name: CustomComponentName;
  inputs?: IProps[];
  canHaveChildren?: boolean;
  image?: string;
}

export const REGISTERED_COMPONENTS: IComponent[] = [
  {
    component: ValueBlade,
    name: CustomComponentName.VALUE_BLADE,
    inputs: [
      {
        name: 'background',
        type: 'string',
        defaultValue: 'white',
        helperText: 'Variant Options: (white, grey, purple)',
      },
      {
        name: 'decorator',
        type: 'string',
        defaultValue: 'Want to learn more about Bambee?',
      },
      {
        name: 'title',
        type: 'string',
        defaultValue: 'Want to learn more about Bambee?',
      },
      {
        name: 'body',
        type: 'richText',
        defaultValue:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      },
    ],
  },
  {
    component: ContentCard,
    name: CustomComponentName.CONTENT_CARD,
    inputs: [
      {
        name: 'decorator',
        type: 'string',
        defaultValue: 'decorator',
      },
      {
        name: 'title',
        type: 'string',
        defaultValue: 'Title',
      },
      {
        name: 'body',
        type: 'richText',
        defaultValue:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ',
      },
      {
        name: 'showLink',
        type: 'boolean',
        defaultValue: false,
      },
      {
        name: 'linkStyle',
        type: 'string',
        enum: ['Link', 'Button'],
        defaultValue: 'Link',
      },
      {
        name: 'buttonText',
        type: 'string',
        defaultValue: 'Button Text',
      },
      {
        name: 'link',
        type: 'string',
        defaultValue: '/',
      },
      {
        name: 'showCheckItems',
        type: 'boolean',
        defaultValue: false,
      },
      {
        name: 'checkItems',
        type: 'list',
        defaultValue: [
          {
            text: 'This is a check list',
          },
        ],
        subFields: [
          {
            name: 'text',
            type: 'string',
          },
        ],
      },
    ],
  },
  {
    component: FeatureSummary,
    name: CustomComponentName.FEATURE_SUMMARY,
    inputs: [
      {
        name: 'headingColorVariant',
        type: String,
        helperText: 'Variant Options: (light-blue, purple)',
      },
      {
        name: 'background',
        type: String,
        helperText: 'Variant Options: (white, grey, purple-gradient)',
        defaultValue: 'white',
      },
      {
        name: 'heading',
        type: String,
        defaultValue: 'Want to learn more about Bambee?',
      },
      {
        name: 'title',
        type: 'richText',
        defaultValue: 'More HR Services to Support Your Business',
      },
      {
        name: 'isDescriptionRequired',
        type: 'boolean',
        defaultValue: false,
      },
      {
        name: 'description',
        type: 'richText',
        defaultValue:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      },
      {
        name: 'isFeatureItemButtonRequired',
        type: 'boolean',
        defaultValue: true,
      },
      {
        name: 'featureItems',
        type: 'list',
        defaultValue: [
          {
            iconVariant: 'clipboard',
            title: 'Keep teams engaged',
            body: 'Improve retention, encourage innovation, and keep your top talent active and cared for.',
            linkText: 'Learn More',
            link: '/',
          },
        ],
        subFields: [
          {
            name: 'iconVariant',
            type: 'string',
            helperText:
              'iconVariant: https://pollen.bambee.com/?path=/docs/fancyicon--gallery',
          },
          {
            name: 'title',
            type: 'string',
          },
          {
            name: 'body',
            type: 'longText',
          },
          {
            name: 'linkText',
            type: 'string',
          },
          {
            name: 'link',
            type: 'string',
          },
        ],
      },
      {
        name: 'collapseBottomPadding',
        type: 'boolean',
        defaultValue: false,
      },
    ],
  },
  {
    component: SimpleImage,
    name: CustomComponentName.SIMPLE_IMAGE,
    inputs: [
      {
        name: 'src',
        type: String,
      },
    ],
  },
  {
    component: SmartImage,
    name: CustomComponentName.SMART_IMAGE,
    inputs: [
      {
        name: 'src',
        type: 'file',
      },
      {
        name: 'alt',
        type: String,
      },
      {
        name: 'lazyLoad',
        type: 'boolean',
        defaultValue: true,
      },
    ],
  },
  {
    component: BambeeLogo,
    name: CustomComponentName.BAMBEE_LOGO,
    inputs: [
      {
        name: 'color',
        type: String,
        defaultValue: 'purple',
      },
    ],
  },
  {
    component: TypeBody,
    name: CustomComponentName.TYPE_BODY,
    canHaveChildren: true,
    inputs: [
      {
        name: 'variant',
        type: String,
      },
      {
        name: 'weight',
        type: String,
      },
      {
        name: 'tag',
        type: String,
      },
    ],
  },
  {
    component: TypeHeading,
    name: CustomComponentName.TYPE_HEADING,
    canHaveChildren: true,
    inputs: [
      {
        name: 'variant',
        type: 'string',
      },
      {
        name: 'weight',
        type: 'string',
      },
      {
        name: 'tag',
        type: 'string',
      },
    ],
  },
  {
    component: TypeOverline,
    name: CustomComponentName.TYPE_OVERLINE,
    canHaveChildren: true,
    inputs: [
      {
        name: 'variant',
        type: String,
      },
      {
        name: 'weight',
        type: String,
      },
      {
        name: 'tag',
        type: String,
      },
    ],
  },
  {
    component: TypeDisplay,
    name: CustomComponentName.TYPE_DISPLAY,
    canHaveChildren: true,
    inputs: [
      {
        name: 'variant',
        type: String,
      },
      {
        name: 'weight',
        type: String,
      },
      {
        name: 'tag',
        type: String,
      },
    ],
  },
  {
    component: BaseIcon,
    name: CustomComponentName.BASE_ICON,
    canHaveChildren: false,
    inputs: [
      {
        name: 'icon',
        type: String,
      },
    ],
  },
  {
    component: BaseDivider,
    name: CustomComponentName.BASE_DIVIDER,
    inputs: [
      {
        name: 'size',
        type: String,
        defaultValue: 'small',
      },
      {
        name: 'dashed',
        type: Boolean,
        defaultValue: false,
      },
      {
        name: 'label',
        type: String,
        defaultValue: null,
      },
      {
        name: 'vertical',
        type: Boolean,
        defaultValue: false,
      },
      {
        name: 'dark',
        type: Boolean,
        defaultValue: false,
      },
    ],
  },
  {
    component: BaseButton,
    name: CustomComponentName.BASE_BUTTON,
    inputs: [
      {
        name: 'variant',
        type: String,
        defaultValue: 'primary',
      },
      {
        name: 'size',
        type: String,
        defaultValue: 'medium',
      },
      {
        name: 'block',
        type: Boolean,
        defaultValue: false,
      },
      {
        name: 'flat',
        type: Boolean,
        defaultValue: false,
      },
      {
        name: 'postIcon',
        type: String,
        defaultValue: '',
      },
      {
        name: 'preIcon',
        type: String,
        defaultValue: '',
      },
      {
        name: 'label',
        type: String,
        defaultValue: '',
      },
      {
        name: 'tag',
        type: String,
        defaultValue: 'button',
      },
    ],
  },
  {
    component: AvatarImage,
    name: CustomComponentName.AVATAR_IMAGE,
    inputs: [
      {
        name: 'size',
        type: Number,
        defaultValue: 40,
      },
      {
        name: 'image',
        type: String,
        defaultValue: '',
      },
      {
        name: 'border',
        type: Boolean,
        defaultValue: false,
      },
      {
        name: 'initials',
        type: String,
        defaultValue: '',
      },
      {
        name: 'name',
        type: String,
        defaultValue: '',
      },
      {
        name: 'square',
        type: Boolean,
        defaultValue: false,
      },
    ],
  },
  {
    component: MobileMenu,
    name: CustomComponentName.MOBILE_MEMU,
  },
  {
    component: TheFooter,
    name: CustomComponentName.THE_FOOTER,
  },
  {
    component: HomeNav,
    name: CustomComponentName.HOME_NAV,
    canHaveChildren: false,

    inputs: [
      {
        name: 'buttonText',
        type: String,
        defaultValue: 'Try Now',
      },
      {
        name: 'showNavOptions',
        type: String,
        defaultValue: 'true',
      },
      {
        name: 'backgroundColor',
        type: String,
        helperText: 'Variant Options: (white, dark)',
        enum: ['white', 'dark'],
        defaultValue: 'white',
      },
      {
        name: 'mobileMenuButtonText',
        type: String,
        defaultValue: 'Log In',
      },
      {
        name: 'text',
        type: String,
        defaultValue: 'Sign In',
      },
      {
        name: 'showButton',
        type: String,
        enum: ['true', 'false'],
        defaultValue: 'true',
      },
      {
        name: 'showText',
        type: String,
        enum: ['true', 'false'],
        defaultValue: 'true',
      },
      {
        name: 'showHamburger',
        type: String,
        enum: ['true', 'false'],
        defaultValue: 'true',
      },
      {
        name: 'makeNavBarFixed',
        type: String,
        enum: ['true', 'false'],
        defaultValue: 'false',
        helperText:
          'Make NavBar fixed. Note: this attribute is only effective when Add margin in the PageHero component is true.',
      },
    ],
  },
  {
    component: BaseCard,
    name: CustomComponentName.BASE_CARD,
    canHaveChildren: true,
    inputs: [
      {
        name: 'fullBleed',
        type: Boolean,
      },
    ],
  },
  {
    component: TextInput,
    name: CustomComponentName.TEXT_INPUT,
    canHaveChildren: false,
    inputs: [
      {
        name: 'disabled',
        type: Boolean,
      },
      {
        name: 'error',
        type: String,
        defaultValue: null,
      },
      {
        name: 'id',
        type: String,
        defaultValue: shortid.generate,
      },
      {
        name: 'invalid',
        type: Boolean,
        defaultValue: false,
      },
      {
        name: 'label',
        type: String,
        defaultValue: null,
      },
      {
        name: 'mask',
        type: Object,
        defaultValue: null,
      },
      {
        name: 'postIcon',
        type: String,
        defaultValue: null,
      },
      {
        name: 'preIcon',
        type: String,
        defaultValue: null,
      },
      {
        name: 'prefix',
        type: String,
        defaultValue: null,
      },
      {
        name: 'postfix',
        type: String,
        defaultValue: null,
      },
      {
        name: 'showReset',
        type: Boolean,
        defaultValue: false,
      },
      {
        name: 'size',
        type: String,
      },
      {
        name: 'value',
        type: [Number, String],
        defaultValue: '',
      },
    ],
  },
  {
    component: Accordion,
    name: CustomComponentName.ACCORDIAN,
    canHaveChildren: true,
    inputs: [
      {
        name: 'headerText',
        type: String,
      },
      {
        name: 'bodyText',
        type: String,
      },
      {
        name: 'iconClasses',
        type: String,
      },
      {
        name: 'icon',
        type: String,
      },
    ],
  },
  {
    component: AccordionPanel,
    name: CustomComponentName.ACCORDIAN_PANEL,
    canHaveChildren: true,
    inputs: [
      {
        name: 'sectionList',
        type: 'list',
        defaultValue: [
          {
            headerText: 'Header Text',
            bodyText: 'Body Text',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4tyhn_b19QsRVnwsRKKlT5IGRBDzglzkbSnQ_iOD4&s',
            isExpanded: true,
          },
          {
            headerText: 'Header Text 2',
            bodyText: 'Body Text 2',
            img: 'https://www.shutterstock.com/image-photo/pure-youth-crazy-english-cocker-260nw-1424153078.jpg',
          },
        ],
        subFields: [
          {
            name: 'headerText',
            type: 'string',
          },
          {
            name: 'bodyText',
            type: 'string',
          },
          {
            name: 'img',
            type: 'file',
          },
          {
            name: 'isExpanded',
            type: 'boolean',
          },
        ],
      },
      {
        name: 'isFullWidth',
        type: 'boolean',
        defaultValue: true,
        helperText:
          'If this option is False, max width will be [1024px]. Otherwise, the component will take up the full width of the parent element.',
      },
      {
        name: 'variant',
        type: 'string',
        defaultValue: 'lavender',
        enum: ['lavender', 'lightLavender', 'white'],
      },
    ],
  },
  {
    component: PricingPlans,
    name: CustomComponentName.PRICING_PLANS,
  },
  {
    component: RegistrationPrompt,
    name: CustomComponentName.REGISTRATION_PROMPT,
    inputs: [
      {
        name: 'buttonId',
        type: String,
      },
      {
        name: 'title',
        type: String,
      },
      {
        name: 'buttonTitle',
        type: String,
      },
      {
        name: 'dropdownLabel',
        type: String,
      },
    ],
  },
  {
    component: RootHomePage,
    name: CustomComponentName.ROOT_HOMEPAGE,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
    canHaveChildren: false,
  },
  {
    component: HomeHero,
    name: CustomComponentName.HOME_HERO,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
      {
        name: 'subtitle',
        type: 'string',
      },
      {
        name: 'promptTitle',
        type: 'string',
      },
      {
        name: 'promptButtonTitle',
        type: 'string',
      },
      {
        name: 'promptDropdownLabel',
        type: 'string',
      },
    ],
    canHaveChildren: true,
  },
  {
    component: EmployeeDropdown,
    name: CustomComponentName.EMPLOYEE_DROPDOWN,
    inputs: [
      {
        name: 'force',
        type: 'boolean',
      },
      {
        name: 'initialValue',
        type: 'string',
      },
      {
        name: 'isInvalid',
        type: 'boolean',
      },
      {
        name: 'placeholder',
        type: 'string',
        defaultValue: 'Number of Employees',
      },
    ],
    canHaveChildren: false,
  },
  {
    component: SplashPage,
    name: CustomComponentName.PARTNERSHIP_PAGE,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
      {
        name: 'whiteLogo',
        type: 'file',
      },
      {
        name: 'whiteLogoSize',
        type: 'string',
        defaultValue: '8',
      },
      {
        name: 'colorLogo',
        type: 'file',
      },
      {
        name: 'colorLogoSize',
        type: 'string',
        defaultValue: '12',
      },
      {
        name: 'companyName',
        type: 'string',
      },
      {
        name: 'customerType',
        type: 'string',
        defaultValue: 'Customer',
      },
      {
        name: 'discount',
        type: 'number',
      },
      {
        name: 'promotion',
        type: 'enum',
        defaultValue: promotionType.SETUP_FEE_DISCOUNT,
        enum: [promotionType.SETUP_FEE_DISCOUNT, promotionType.DOLLAR_TRIAL],
      },
    ],
  },
  {
    component: ReviewsRoot,
    name: CustomComponentName.REVIEWS,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: InsuranceRoot,
    name: CustomComponentName.INSURANCE,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: ScheduleCallLanding,
    name: CustomComponentName.SCHEDULE_CALL,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: PricingRoot,
    name: CustomComponentName.PRICING,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: PartnersRoot,
    name: CustomComponentName.PARTNERS,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: ProductRoot,
    name: CustomComponentName.PRODUCT,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: FaqRoot,
    name: CustomComponentName.FAQROOT,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: TrainingRoot,
    name: CustomComponentName.TRAINING,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: AboutRoot,
    name: CustomComponentName.ABOUT,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: ComplianceRoot,
    name: CustomComponentName.COMPLIANCE,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
    canHaveChildren: true,
  },
  {
    component: ComplianceTemplate,
    name: CustomComponentName.COMPLIANCE_TEMPLATE,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: LegalRoot,
    name: CustomComponentName.LEGAL,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: LegalTemplate,
    name: CustomComponentName.LEGAL_TEMPLATE,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: IndustryRoot,
    name: CustomComponentName.INDUSTRIES,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: IndustryTemplate,
    name: CustomComponentName.INDUSTRY_TEMPLATE,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: Catalog,
    name: CustomComponentName.BLOG_CATALOG,
    inputs: [
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: ReferredBlogs,
    name: CustomComponentName.REFERRED_BLOGS,
  },
  {
    component: BlandHero,
    name: CustomComponentName.BLAND_HERO,
  },
  {
    component: PurpleHexContainer,
    name: CustomComponentName.PURPLE_HEX_CONTAINER,
    canHaveChildren: true,
  },
  {
    component: BaseFAQ,
    name: CustomComponentName.FAQ,
    canHaveChildren: false,
    inputs: [
      {
        name: 'FAQItems',
        type: 'list',
        subFields: [
          {
            name: 'question',
            type: 'richText',
            defaultValue:
              'What is employee performance and why is it important?',
          },
          {
            name: 'answer',
            type: 'richText',
            defaultValue:
              'Employee performance pertains to the level of value they’re bringing to the table at work, measured against their level of training, background understanding, and industry experience. Employee performance is helpful to track, as this can highlight new areas and training opportunities in your staff – as well as opportunities to praise and celebrate.',
          },
        ],
      },
      {
        name: 'title',
        type: 'string',
      },
    ],
  },
  {
    component: BaseCTABlade,
    name: CustomComponentName.CTA_BLADE,
    canHaveChildren: false,
    inputs: [
      {
        type: String,
        name: 'variant',
        helperText:
          'Variant Options: (dark, white, grey, neutral, lightpurple, purplegradient)',
        defaultValue: 'dark',
      },
      {
        type: String,
        name: 'title',
        defaultValue: 'Want to learn more about Bambee?',
      },
      {
        type: String,
        name: 'headline',
        defaultValue: 'Want to learn more about Bambee?',
      },
      {
        type: 'richText',
        name: 'body',
        defaultValue:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      },
      {
        type: String,
        name: 'buttonText',
        defaultValue: 'See how we can help',
      },
      {
        type: String,
        name: 'buttonLink',
        defaultValue: '',
      },
      {
        type: String,
        name: 'showButton',
        defaultValue: 'true',
      },
    ],
  },
  {
    component: BaseTestimonial,
    name: CustomComponentName.TESTIMONIAL,
    canHaveChildren: false,
    inputs: [
      {
        type: String,
        name: 'variant',
        helperText: 'Variant Options: (white, grey, floralwhite)',
        defaultValue: 'white',
      },
      {
        type: 'richText',
        name: 'text',
        defaultValue:
          "I highly recommend Bambee to any small business owner looking for HR support. Their dedicated HR manager helped me navigate complex employment laws and policies. When an employee threatened to sue me for wrongful termination, Bambee's HR manager provided expert guidance and support that helped me resolve the issue without going to court. Thanks to Bambee, I can focus on running my business with confidence and peace of mind.",
      },
      {
        type: 'file',
        name: 'image',
        defaultValue: '',
        allowedFileTypes: ['jpeg', 'png', 'svg', 'jpg', 'pdf', 'webp'],
      },
      {
        type: 'file',
        name: 'icon',
        allowedFileTypes: ['jpeg', 'png', 'svg', 'jpg', 'webp'],
      },
      {
        name: 'information',
        type: 'object',
        defaultValue: {
          name: 'Hannah Olinger',
          businessName: 'Banana Coffee Shop',
          numberOfEmployees: '32',
        },
        subFields: [
          {
            name: 'name',
            type: 'string',
          },
          {
            name: 'businessName',
            type: 'string',
          },
          {
            name: 'numberOfEmployees',
            type: 'string',
          },
        ],
      },
    ],
  },
  {
    component: ZigZagLayoutContainer,
    name: CustomComponentName.ZIG_ZAG_LAYOUT_CONTAINER,
    canHaveChildren: true,
  },
  {
    component: ZigZagLayout,
    name: CustomComponentName.ZIG_ZAG_LAYOUT,
    canHaveChildren: true,
    inputs: [
      {
        type: 'file',
        name: 'image',
      },
      {
        type: 'boolean',
        name: 'isImageLeftSide',
        defaultValue: true,
      },
      {
        type: 'string',
        name: 'imageExplainerText',
        required: true,
        defaultValue: '',
        helperText:
          'Write a detailed description of the image. This will help with accessibility and SEO.',
      },
      {
        type: 'boolean',
        name: 'lazyLoad',
        defaultValue: true,
      },
    ],
  },
  {
    component: Hero,
    name: CustomComponentName.PAGE_HERO,
    inputs: [
      {
        type: 'richText',
        name: 'title',
        defaultValue: 'The Only Dedicated HR Manager Solution',
      },
      {
        type: 'richText',
        name: 'headline',
        defaultValue:
          'Performance Management and Feedback for Happy and Productive Workers',
      },
      {
        type: 'richText',
        name: 'body',
        defaultValue:
          'Structured feedback and routine performance management can drive productivity and improve the employee experience. Bambee’s performance management tools and expert HR guidance will help you cultivate a highly productive workforce.',
      },
      {
        type: String,
        name: 'buttonText',
        defaultValue: 'See how we can help',
      },
      {
        type: 'file',
        name: 'image',
        helperText: 'Primary Hero image.',
      },
      {
        type: 'boolean',
        name: 'lazyLoad',
        defaultValue: false,
      },
      {
        type: String,
        name: 'imageExplainerText',
        defaultValue: '',
        required: true,
        helperText:
          'Write a detailed description of the image. This will help with accessibility and SEO.',
      },
      {
        type: String,
        name: 'cropLocation',
        defaultValue: 'center',
        helperText:
          'Indicate the position where the image should be cropped towards. Selections: [left, right, bottom, center].',
      },
      {
        type: String,
        name: 'link',
        required: true,
        helperText: 'Provide a URL for the button to route to.',
      },
      {
        type: 'string',
        name: 'colorTheme',
        enum: ['light', 'dark'],
        defaultValue: 'light',
      },
      {
        type: 'boolean',
        name: 'isImageFullBleed',
        defaultValue: false,
      },
      {
        type: 'boolean',
        name: 'addMarginTop',
        defaultValue: false,
        helperText:
          'Add Margin to the top of the hero container. Note: this attribute is only effective when makeBarFixed in the NavBar component is true.',
      },
      {
        type: 'boolean',
        name: 'addResponsiveBottomMargin',
        defaultValue: true,
        helperText:
          'Some designs need extra margins at the bottom (true) of the image and some do not (false). Note: this attribute is only effective when isImageFullBleed is false.',
      },
      {
        type: 'boolean',
        name: 'addRegistrationPrompt',
        defaultValue: false,
        helperText:
          'Enable registration prompt feature, which adds Registration Form with a dropdown selection and button.',
      },
      {
        type: 'file',
        name: 'subImage',
        helperText: 'Sub Hero Image for the registration prompt.',
      },
      {
        type: String,
        name: 'subImageExplainer',
        helperText: 'Sub Hero Image explainer text.',
      },
      {
        type: 'string',
        name: 'typographyVariant',
        enum: ['dollarTrial', 'default'],
        helperText:
          'Typography variants are bundles of style including: font, line height, letter spacing, centering, margin.',
        defaultValue: 'default',
      },
    ],
  },
  {
    component: BaseBenefitsBlade,
    name: CustomComponentName.BENEFITS_BLADE,
    canHaveChildren: false,
    inputs: [
      {
        type: String,
        name: 'headline',
        defaultValue: 'Want to learn more about Bambee?',
      },
      {
        type: String,
        name: 'title',
        defaultValue: 'Save on compliance and manage your risks',
      },
      {
        type: 'richText',
        name: 'description',
        defaultValue:
          'Compliance problems can be costly – and they can also be avoided with a strong HR management software that addresses employee training, compliance support and readily-available HR management on demand. Introducing: Bambee. ',
      },
      {
        name: 'complianceList',
        type: 'list',
        subFields: [
          {
            name: 'title',
            type: String,
            defaultValue: 'Save on compliance',
          },
          {
            name: 'description',
            type: 'richText',
            defaultValue:
              'Compliance problems can be costly – and they can also be avoided with a strong HR management software.',
          },
          {
            name: 'icon',
            type: String,
            defaultValue: 'user',
            helperText:
              'icon: https://pollen.bambee.com/?path=/story/baseicon--gallery',
          },
        ],
      },
    ],
  },
  {
    component: PageSubHero,
    name: CustomComponentName.PAGE_SUB_HERO,
    inputs: [
      {
        name: 'backgroundColorVariant',
        type: 'string',
        helperText: 'Variant Options: (white, grey)',
      },
      {
        name: 'showLastItemOnMobile',
        type: 'boolean',
        defaultValue: 'true',
      },
      {
        name: 'items',
        type: 'list',
        subFields: [
          {
            name: 'img',
            type: 'file',
          },
          {
            name: 'label',
            type: 'string',
          },
          {
            name: 'imageExplainerText',
            type: 'string',
            required: true,
            helperText:
              'Write a detailed description of the image. This will help with accessibility and SEO.',
          },
        ],
      },
    ],
  },
  {
    component: SimpleFooter,
    name: CustomComponentName.SIMPLE_FOOTER,
  },
  {
    component: ProfileFactoid,
    name: CustomComponentName.PROFILE_FACTOID,
    canHaveChildren: false,
    inputs: [
      {
        type: String,
        name: 'name',
        defaultValue: 'Ashley Medows',
      },
      {
        type: String,
        name: 'position',
        defaultValue: 'HR Manager',
      },
      {
        type: 'file',
        name: 'image',
      },
      {
        type: String,
        name: 'imageExplainerText',
        defaultValue: '',
        required: true,
        helperText:
          'Write a detailed description of the image. This will help with accessibility and SEO.',
      },
      {
        name: 'profileCardItems',
        type: 'list',
        subFields: [
          {
            name: 'title',
            type: String,
            defaultValue: 'Employee Relations & HR Problem Solving',
          },
          {
            name: 'description',
            type: 'richText',
            defaultValue:
              'The most sensitive issues require rich dialog. Your HR Manager engages with you to create the right outcomes for your business.',
          },
          {
            name: 'icon',
            type: String,
            defaultValue: 'user',
            helperText:
              'icon: https://pollen.bambee.com/?path=/story/baseicon--gallery',
          },
        ],
      },
    ],
  },
  {
    component: Factoid,
    name: CustomComponentName.FACTOID,
    inputs: [
      {
        name: 'title',
        type: 'string',
        defaultValue: 'Did you know?',
      },
      {
        name: 'description',
        type: 'string',
        defaultValue:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin euismod accumsan nisi, ornare lobortis tortor. ',
      },
    ],
  },
  {
    component: ProfileCardVue,
    name: CustomComponentName.PROFILE_CARD,
    inputs: [
      {
        name: 'profileCardItems',
        type: 'list',
        subFields: [
          {
            name: 'title',
            type: String,
            defaultValue: 'Employee Relations & HR Problem Solving',
          },
          {
            name: 'description',
            type: 'richText',
            defaultValue:
              'The most sensitive issues require rich dialog. Your HR Manager engages with you to create the right outcomes for your business.',
          },
          {
            name: 'icon',
            type: String,
            defaultValue: 'user',
            helperText:
              'icon: https://pollen.bambee.com/?path=/story/baseicon--gallery',
          },
        ],
      },
    ],
  },
];

export default REGISTERED_COMPONENTS;
